module.exports = __webpack_public_path__ + "static/media/18.e652f0a5.mp3";